import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'antd';
import { DropdownSelect } from '../../dropdown-select/DropdownSelect';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { CompaniesService } from '../../../services/companiesService';
import CreateItemByInput from '../../createItemByInput/CreateItemByInput';
import { ModalEditContact } from '../../../views/CustomerDetails/components/ModalEditContact';

export const SelectContact = ({ selectedContact, onChange, selectedCompanyId, enabledActions = false }) => {
  const { translate: t } = useDictionaryTranslation();
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [idContact, setIdContact] = useState('');

  const selectContact = (item) => {
    let selectedOption;
    if (item) selectedOption = item.data ?? contacts.find((s) => s._id === item.value);
    onChange(selectedOption);
  };


  const getContacts = useCallback(
    async (search) => {
      if (!selectedCompanyId) return;
      setLoading(true);
      try {
        const { contacts: contactsList } = await CompaniesService.getAllContacts({
          search,
          idCompany: selectedCompanyId,
        });
        setContacts(contactsList);
        if (contactsList?.length === 1 && !selectedContact) {
          selectContact({
            value: contactsList[0]._id,
            label: contactsList[0].name,
            data: contactsList[0],
          });
        }
      } catch (error) {
        setContacts([]);
      } finally {
        setLoading(false);
      }
    },
    [selectedCompanyId, selectedContact],
  );

  const onClose = () => {
    setShowModal(false);
    getContacts();
    setIdContact();
  };

  const onCreateContact = () => {
    setShowModal(true);
  };

  const onEditContact = () => {
    setIdContact(selectedContact?._id);
    setShowModal(true);
  };

  useEffect(() => {
    getContacts();
  }, [getContacts]);

  const getOptionData = useCallback((contact) => {
    return {
      value: contact._id,
      label: contact.name,
    };
  }, []);

  return (
    <>
      <Row justify="end" style={{ gap: '5px' }}>
        <DropdownSelect
          style={{ minWidth: '70%', flex: 1, width: 'unset' }}
          placeholderText={t('contactPlaceholder')}
          isLoading={loading}
          onChange={selectContact}
          options={contacts}
          value={selectedContact}
          onSearch={getContacts}
          getOptionData={getOptionData}
        />

        {enabledActions ? (
          <>
            <CreateItemByInput
              onCreate={onCreateContact}
              disableCreate={!selectedCompanyId}
              disableEdit={!selectedContact?._id}
              onEdit={onEditContact}
            />
            <ModalEditContact
              show={showModal}
              handleClose={onClose}
              customerId={selectedCompanyId}
              contactId={idContact}
              onChangeContact={onChange}
            />
          </>
        ) : null}
      </Row>
    </>
  );
};

SelectContact.propTypes = {
  selectedContact: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  selectedCompanyId: PropTypes.string,
  enabledActions: PropTypes.bool,
};
